import React, { useContext, type PropsWithChildren } from 'react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { useEntryPoint } from '@atlassian/jira-entry-point/src/controllers/use-entry-point/index.tsx';
import { createUseEntryPointContext } from '@atlassian/jira-entry-point/src/controllers/utils/create-use-entry-point-context/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useFormatRulesSerialisedJql } from '@atlassian/jira-business-conditional-formatting-sidebar/src/controllers/format-rules-store/index.tsx';
import { conditionalFormattingSidebarEntryPoint } from '../../ui/sidebar-content/entrypoint.tsx';
import type { Props } from './types.tsx';

const ConditionalFormattingEntryPointContext =
	createUseEntryPointContext<typeof conditionalFormattingSidebarEntryPoint>();

export const ConditionalFormattingEntrypointProvider = ({
	children,
	projectKey,
}: PropsWithChildren<Props>) => {
	const cloudId = useCloudId();
	// TODO: JSC-2350 - We could calculate hydrateJQL directly here and killed all the old Business store
	const [hydrateJql] = useFormatRulesSerialisedJql();

	const createObjectEntryPoint = useEntryPoint(conditionalFormattingSidebarEntryPoint, {
		projectKey,
		cloudId,
		hydrateJql,
	});

	return (
		<ConditionalFormattingEntryPointContext.Provider value={createObjectEntryPoint}>
			{children}
		</ConditionalFormattingEntryPointContext.Provider>
	);
};

export const MaybeConditionalFormattingEntryPointProvider = componentWithCondition(
	() => fg('jira_list_conditional_formatting'),
	ConditionalFormattingEntrypointProvider,
	({ children }: PropsWithChildren<Props>) => <>{children}</>,
);

export const useConditionalFormattingEntryPoint = () =>
	useContext(ConditionalFormattingEntryPointContext);
